export default "/images/vendor/@coreui/icons/svg/flag/cif-mu.svg?34ae5c83391a3b005148ece95947f09d";